import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

import {WorksheetTaskStatusType} from '../WorksheetConstants';

export const optimisticStepStatusState = makeUseGlobalClientState<WorksheetTaskStatusType | null>(null);
